import * as React from 'react'
import './styles/HeaderContainer.css'
import { get } from 'lodash'

export default class RenewalHeaderContainer extends React.Component<any, any> {

    constructor(props: any) {
        super(props)

        this.state = {
            typeSelected: this.props.selected ? this.props.selected : this.props.titles[0],
            selectorOpened: false,
        }
    }

    changeType = (element) => {
        if (element !== this.state.typeSelected) {
            this.setState({ typeSelected: element, selectorOpened: false })
            this.props.triggerAction(element)
        }
    }
    render() {
        const { sections, fullwidth, className, pretitle } = this.props
        const { typeSelected } = this.state
        return (
            <div className={`renewal_header header${(fullwidth) ? ' header--full' : ''} ${className || ''}`}>
                <div className="header_inner">

                    <div className="header__title">
                        {pretitle && <h3>{pretitle}</h3>}
                    </div>

                    <div className="header__content">
                        <div className="renewal_section">
                            {
                                Object.entries(sections).map(([key, value]) => {
                                    if (get(value, 'show') === false) {
                                        return null
                                    }
                                    return (
                                        <div
                                            key={key}
                                            className={`${(typeSelected === key) ? 'selected' : ''}`}
                                            onClick={() => this.changeType(key)}
                                        >
                                            {get(value, 'title')}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/HeaderContainer/RenewalHeaderContainer.tsx